var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4VPavillion = function Svg4VPavillion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.141 9.859 24 4.001 9.859 9.859 4.001 24l5.858 14.142L24 43.999l14.141-5.857L43.998 24zM40.13 22.5H27.621l8.845-8.845zM25.5 7.871l8.845 3.664-8.845 8.844zm-3 12.508-8.844-8.845L22.5 7.871zm0 19.751-8.844-3.664 8.844-8.845zm3-12.509 8.845 8.845L25.5 40.13zM11.534 13.655l8.845 8.845H7.87zM7.87 25.5h12.509l-8.845 8.845zm28.596 8.845L27.621 25.5H40.13z"
  })))));
};
export default Svg4VPavillion;